import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import { ApiGetClientEntityId, ApiGetResend2FA, ApiRegionVenues, ApiUsersLogin } from '../../apiService/Core/Apicall'
import { Images } from '../../global/GloblImages'
import storage from '../../utils/storage'
import { useDispatch } from 'react-redux'
import { setallclientEntityIds } from '../../global/config/Reducer/WholeGroupSlice'
import { setRegion } from '../../global/config/Reducer/RegionSlice'




function OtpVerification() {
    const location = useLocation()

    const { username, password, tempToken } = location.state || {}
    const navigate = useNavigate()
    const [error, setError] = useState('')
    const [otp, setOtp] = useState<string[]>(Array(6).fill(''))
    const [showerror, setShowerror] = useState(false)
    const dispatch = useDispatch()
    const inputRefs = useRef<(HTMLInputElement | null)[]>([])
    const [token, setToken] = useState()
    const [userName, setUserName] = useState()
    const [Password, setPassword] = useState()
    const { MMLogo } = Images()
    const [resendTimer, setResendTimer] = useState(120)


    useEffect(() => {
        if (resendTimer <= 0) return

        const timer = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(timer)
                    return 0
                }

                return prev - 1
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [resendTimer])


    const formatTimer = (seconds: number) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60

        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
    }

    useEffect(() => {
        if (!username || !password || !tempToken) {
            const userData = JSON.parse(localStorage.getItem("userData") || "{}");
            if (!userData.userId) {
                navigate('/login', { replace: true })
                return
            }
            else {
                navigate('/maindashboard/dashboard', { replace: true })
                return
            }
        }
        setToken(tempToken)
        setPassword(password)
        setUserName(username)
        navigate(location.pathname, {
            replace: true,
            state: null
        })

    }, [])
    const handleOtpChange = (value: string, index: number) => {
        // Only allow numbers
        if (!/^\d*$/.test(value)) return

        const newOtp = [...otp]
        newOtp[index] = value.slice(-1)

        setOtp(newOtp)

        // Move to next input
        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus()
        }
    }

    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number
    ) => {
        // Move to previous input on backspace
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus()
        }
    }

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault()

        const pastedOtp = e.clipboardData
            .getData('text')
            .replace(/\D/g, '')
            .slice(0, 6)

        if (!pastedOtp) return

        const newOtp = Array(6).fill('')

        pastedOtp.split('').forEach((digit, index) => {
            newOtp[index] = digit
        })

        setOtp(newOtp)

        inputRefs.current[
            Math.min(pastedOtp.length, 5)
        ]?.focus()
    }

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault()

        setShowerror(true)
        const otpValue = otp.join('')

        if (otpValue.length !== 6) {
            setError('Please enter the 6-digit OTP')
            return
        }

        const Apidata = {
            emailId: userName,
            password: Password,
            tempToken: token,
            otp: otpValue
        }
        try {
            const response = await ApiUsersLogin(Apidata)
            storage.setItem('token', response.token)
            localStorage.setItem('token', response.token)
            if (
                response.userDetails.role.roleName === 'clientadmin' &&
                window.location.hostname.includes('client') &&
                response.otherDetails.ClientGroupName.clientGroupName !== "ALDI" &&
                response.otherDetails.ClientGroupName.clientGroupName !== "BLOOMS"
            ) {
                const groupName =
                    response.otherDetails.ClientGroupName.clientGroupName;

                // session storage
                storage.setItem('ClientGroupName', groupName);

                // local storage
                localStorage.setItem('ClientGroupName', groupName);
            }

            if (
                response.userDetails.role.roleName !== 'clientadmin' &&
                window.location.hostname.includes('client') &&
                response.otherDetails.clientGroupName !== "ALDI" &&
                response.otherDetails.clientGroupName !== "BLOOMS"
            ) {
                const groupName =
                    response.otherDetails.clientGroupName;

                // session storage
                storage.setItem('ClientGroupName', groupName);

                // local storage
                localStorage.setItem('ClientGroupName', groupName);
            }
            const clientgroupname = storage.getItem('ClientGroupName')
            if ((storage.getItem("token") && response.userDetails.role.roleName === 'clientadmin') ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
                storage.setItem('userRole', response.userDetails.role.roleName)
                localStorage.setItem('userRole', response.userDetails.role.roleName)
                response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientId', response.otherDetails.ClientID)
                response.userDetails.role.roleName === 'clientadmin' && localStorage.setItem('clientId', response.otherDetails.ClientID)
                storage.setItem('userData', JSON.stringify(response.userDetails));
                storage.setItem('userOtherData', JSON.stringify(response.otherDetails));
                localStorage.setItem('userData', JSON.stringify(response.userDetails));
                localStorage.setItem('userOtherData', JSON.stringify(response.otherDetails));
                response?.otherDetails?.areas?.[0]?.areaId && storage.setItem('areaId', response?.otherDetails?.areas?.[0]?.areaId)
                response?.otherDetails?.areas?.[0]?.areaName && storage.setItem('areaName', response?.otherDetails?.areas?.[0]?.areaName)
                response.userDetails.role.roleName !== 'clientadmin' && storage.setItem('cssNPS', response?.otherDetails?.canClientSeeNPSScore)
                // response?.otherDetails?.venues?.[0]?.venueName && storage.setItem('cssNPS', response?.otherDetails?.venues?.[0]?.canClientSeeNPSScore)
                storage.setItem('INF', response?.otherDetails?.hideFixIt);
                storage.setItem('ISC', response?.otherDetails?.hideSiteComparison);
                response?.userDetails?.role?.roleName !== 'clientadmin' && response?.otherDetails?.clientGroupName === 'ALDI' && storage.setItem('clientEntityName', response?.otherDetails?.clientEntityName)
                const response2 = response.userDetails.role.roleName === 'clientadmin' && await ApiGetClientEntityId(response.otherDetails.ClientID)
                response2 && storage.setItem("ratingJson", response2.data[0][0]?.ratingJson)
                const allClientEntityIds = response2?.data?.[0]
                    ?.sort((a: any, b: any) => a.entityCode === "SON" ? Number(a.clientEntityId) - Number(b.clientEntityId) : Number(b.clientEntityId) - Number(a.clientEntityId))
                    ?.map((item: any) => item.clientEntityId)
                    ?.join(",") || "";
                dispatch(setallclientEntityIds(allClientEntityIds))
                storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', response2.data[0][0]?.isAllowDownloadWithoutComments);
                storage.getItem('userRole') === 'clientadmin' && storage.setItem('INF', response2.data[0][0]?.hideFixIt);
                storage.getItem('userRole') === 'clientadmin' && storage.setItem('ISC', response2.data[0][0]?.hideSiteComparison);
                storage.getItem('userRole') === 'clientadmin' && storage.setItem('cssNPS', response2.data[0][0]?.canClientSeeNPSScore);
                storage.setItem('clientEntityId', response.userDetails.role.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : response.otherDetails.clientEntityId)
                response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
                storage.setItem('ActiveTask', "Dashboard")
                navigate("/maindashboard/dashboard");
            }
            else {
                alert("Invalid Acess")
            }

            // toast.success(response.message)
            if (storage.getItem("clientEntityId") && (storage.getItem('ClientGroupName') === 'ALDI' || storage.getItem('ClientGroupName') === 'BLOOMS') && response.userDetails.role.roleName === 'clientadmin' ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3?.data))
            }

        }
        catch (error: any) {
            toast.error(error)
            console.log(error)
            // toast.error(error)
        }
    }

    const ResendOTP = async () => {
        if (resendTimer > 0) return
        try {
            const loginData = {
                tempToken: token,
            }
            const response: any = await ApiGetResend2FA(loginData)
            if (response?.status) {
                // setToken(response?.tempToken)
                setResendTimer(120)
                toast.success(response?.message)
            }
        } catch (error: any) {
            toast.error(error || "Something went worng")
            console.error('Error during API call:', error)
        }
    }

    return (
        <Box className='p-50-120 d-flex flex-column gap-5' height={{ xs: "80vh", sm: '100vh' }}>
            <ToastContainer />
            <Box component='img' className='mb-2 mx-auto' width='50%' zIndex={2} src={MMLogo} height='auto' alt='logo' />
            <Box className='flex-grow-1 mt-5' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>Verify OTP</Typography>
                <Typography className='fs-18 '>Enter the 6-digit OTP sent to your email.</Typography>
                <Box>
                    <form onSubmit={handleVerify}>
                        <FormControl className='col-12 mt-5'>
                            <span>OTP{" "}
                                <sup>
                                    <span className='text-danger'>*</span>
                                </sup>
                            </span>
                            <Box display="flex" gap={1} justifyContent="center">
                                {otp.map((digit, index) => (
                                    <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                        <TextField
                                            id={`otp-${index}`}
                                            value={digit}
                                            onChange={(e) =>
                                                handleOtpChange(
                                                    e.target.value,
                                                    index
                                                )
                                            }
                                            onKeyDown={(e: any) =>
                                                handleKeyDown(e, index)
                                            }
                                            onPaste={handlePaste}
                                            inputRef={(element) => {
                                                inputRefs.current[index] = element
                                            }}
                                            variant="outlined"
                                            className='otp'
                                            inputProps={{
                                                maxLength: 1,
                                                style: { textAlign: 'center', color: "var(--primary-color)", fontSize: '1.5rem', padding: '8px' }
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: '10px'
                                                }
                                            }}

                                        />

                                    </Box>
                                ))}
                            </Box>
                        </FormControl>
                        <Box className='d-flex align-items-center justify-content-between'>
                            {error && (
                                <div
                                    className='text-danger  text-center'
                                    style={{ marginTop: '8px', fontSize: '14px' }}
                                >
                                    {error}
                                </div>
                            )}
                            {resendTimer > 0
                                ?
                                <Typography variant='subtitle2' className='text-end d-block mt-2'>Resend OTP in {formatTimer(resendTimer)}</Typography>
                                :
                                <Typography sx={{ color: 'var(--primary-color)', textDecoration: 'underline', cursor: 'pointer' }} className='text-end d-block mt-2' onClick={ResendOTP}>Resend OTP?</Typography>
                            }
                        </Box>
                        <Button
                            type='submit'
                            fullWidth
                            className='button-primary py-2 mt-5'
                        >
                            Verify OTP
                        </Button>
                    </form>

                </Box>
            </Box>
        </Box>
    )
}

export default OtpVerification